import { useState } from "react";
import { Button } from "./ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "./ui/command";
import { CaretDown, Check } from "@phosphor-icons/react";

/** Dropdown pelanggan/vendor dengan pencarian otomatis (ketik nama → daftar terfilter). */
export function PartnerCombobox({ partners, value, onChange, placeholder = "Ketik nama untuk mencari…", testid = "partner-combobox" }) {
  const [open, setOpen] = useState(false);
  const selected = partners.find((p) => p.id === value);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button type="button" variant="outline" role="combobox" aria-expanded={open} data-testid={testid} className="w-full justify-between font-normal">
          <span className="truncate">{selected ? selected.name : placeholder}</span>
          <CaretDown size={14} className="ml-2 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[--radix-popover-trigger-width] p-0" align="start">
        <Command>
          <CommandInput placeholder="Cari nama…" data-testid={`${testid}-search`} />
          <CommandList>
            <CommandEmpty>Nama tidak ditemukan.</CommandEmpty>
            <CommandGroup>
              {partners.map((p) => (
                <CommandItem key={p.id} value={p.name} onSelect={() => { onChange(p); setOpen(false); }} data-testid={`${testid}-opt-${p.id}`}>
                  <Check size={14} className={`mr-2 shrink-0 ${p.id === value ? "opacity-100" : "opacity-0"}`} />
                  <span className="truncate">{p.name}</span>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}

export default PartnerCombobox;
